import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { register } from '../store/slices/authSlice';

const RegisterPage: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { loading, error } = useAppSelector((s) => s.auth);
  const [form, setForm] = useState({
    username: '',
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    phone: '',
    position: '',
    hireDate: new Date().toISOString().split('T')[0],
    baseRate: 100,
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await dispatch(register(form));
    if (register.fulfilled.match(result)) navigate('/workspace');
  };

  const field = (label: string, key: keyof typeof form, type = 'text') => (
    <div style={{ marginBottom: '12px' }}>
      <label style={{ display: 'block', marginBottom: '4px', color: 'var(--crm-text)' }}>{label}</label>
      <input
        type={type}
        value={form[key]}
        onChange={(e) =>
          setForm({
            ...form,
            [key]: type === 'number' ? Number(e.target.value) : e.target.value,
          })
        }
        style={{
          width: '100%',
          padding: '8px',
          border: '1px solid var(--crm-border)',
          borderRadius: 'var(--crm-radius-sm)',
          background: 'var(--crm-input-bg)',
          color: 'var(--crm-text)',
          boxSizing: 'border-box',
        }}
        required
      />
    </div>
  );

  return (
    <div className="auth-page">
      <div className="auth-card auth-card--wide">
        <h2 style={{ textAlign: 'center', color: 'var(--crm-text)', marginBottom: '20px' }}>Реєстрація</h2>
        {error && (
          <div
            style={{
              background: 'var(--crm-danger-bg)',
              color: 'var(--crm-danger)',
              border: '1px solid var(--crm-danger)',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '12px',
            }}
          >
            {error}
          </div>
        )}
        <form onSubmit={handleSubmit}>
          {field('Логін', 'username')}
          {field('Email', 'email', 'email')}
          {field('Пароль', 'password', 'password')}
          {field("Ім'я", 'firstName')}
          {field('Прізвище', 'lastName')}
          {field('Телефон', 'phone')}
          {field('Посада', 'position')}
          {field('Дата прийому', 'hireDate', 'date')}
          {field('Базова ставка (год.)', 'baseRate', 'number')}
          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              background: 'var(--crm-success-bg)',
              color: 'var(--crm-success)',
              border: '1px solid var(--crm-success)',
              borderRadius: 'var(--crm-radius-sm)',
              cursor: 'pointer',
              fontSize: '16px',
              marginTop: '8px',
            }}
          >
            {loading ? 'Реєстрація...' : 'Зареєструватись'}
          </button>
        </form>
        <p style={{ textAlign: 'center', marginTop: '16px', color: 'var(--crm-text-muted)' }}>
          Вже є акаунт?{' '}
          <Link to="/login" style={{ color: 'var(--crm-accent)' }}>
            Вхід
          </Link>
        </p>
      </div>
    </div>
  );
};

export default RegisterPage;
